import { create } from 'zustand'

interface ConflictInfo {
  id: string
  mutationKey: readonly unknown[]
  variables: unknown
  serverData: unknown
  errorMessage: string
}

interface ConflictState {
  conflicts: ConflictInfo[]
  addConflict: (conflict: ConflictInfo) => void
  removeConflict: (id: string) => void
}

export const useConflictStore = create<ConflictState>((set) => ({
  conflicts: [],
  addConflict: (conflict) => set((state) => ({ conflicts: [...state.conflicts, conflict] })),
  removeConflict: (id) => set((state) => ({ conflicts: state.conflicts.filter((c) => c.id !== id) })),
}))
